import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import GeneralPageMain from 'lumen/components/general/page/main';
import HotelAccountSelectionPage from 'lumen/components/hotel/account-selection-page';
import SettingsDrawerSidebar from 'lumen/components/settings/drawer/sidebar';
import type HotelAccountSelectionController from 'lumen/controllers/hotel/account-selection';
import contextualPageTitle from 'lumen/helpers/contextual-page-title';

interface HotelAccountSelectionSignature {
  Args: {
    controller: HotelAccountSelectionController;
  };
}

const HotelAccountSelection = <template>
  {{pageTitle
    (contextualPageTitle (t "general.account_selection"))
    replace=true
  }}

  {{#if @controller.isSettingsContext}}
    <GeneralPageMain class="navbar-settings">
      <SettingsDrawerSidebar />
      <div class="content-wrapper main-content flex flex-col gap-0">
        <HotelAccountSelectionPage
          @onContinue={{@controller.handleContinue}}
          @redirectTo={{@controller.redirectTo}}
        />
      </div>
    </GeneralPageMain>
  {{else}}
    <HotelAccountSelectionPage
      @onContinue={{@controller.handleContinue}}
      @redirectTo={{@controller.redirectTo}}
    />
  {{/if}}
</template> satisfies TOC<HotelAccountSelectionSignature>;

export default HotelAccountSelection;
